import {
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { EXCLUDE_QUIT_STAFF } from "app/appConfig";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import IconDelete from "app/common/Icon/IconDelete";
import {
  ALLOCATION_UPON_PAYMENT,
  LEAD_SOURCE_LEVEL,
} from "app/common/LocalConst";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingPosition } from "app/services/PositionService";
import { pagingStaff } from "app/services/StaffService";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { renderArrayString } from "utils";

const StaffRevenuesFee = ({
  editable,
  index,
  row,
  POSITION_CODES,
  hiddenAddStaff,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  let arraySourceStaff = values?.items[
    index
  ]?.invoiceItem?.staffRevenues?.filter(
    (el) => el?.type !== ALLOCATION_UPON_PAYMENT
  );

  let arraySourceStaffSet = [
    ...new Map(
      arraySourceStaff?.map((item) => [item?.source?.id, item?.source])
    ).values(),
  ];

  // lên đơn nguồn gì thì lúc thanh toán cũng nguồn đó
  let arrayselectedSourceCodes = arraySourceStaffSet?.map((el) => el?.code)?.filter(Boolean);
  // let arrayselectedSourceCodes = arraySourceStaffSet?.flatMap((el) => {
  //   if (el?.selectedSources?.length > 0) {
  //     return el?.selectedSources?.map((source) => source?.code);
  //   }
  //   return [];
  // });

  return (
    <>
      <FieldArray name={`items.[${index}].staffRevenues`}>
        {({ remove, push }) => (
          <>
            <div className="staff-table-wrapper" style={{ overflowX: "auto" }}>
              <table style={{ minWidth: 650, width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ backgroundColor: "none" }} width="3%">
                      {/* STT */}
                    </th>

                    <th
                      style={{ backgroundColor: "none" }}
                      width="40%"
                      colSpan={2}
                    >
                      {/* nguồn */}
                      Nguồn đơn hàng:
                      {renderArrayString(arraySourceStaffSet, "name")}
                    </th>

                    <th style={{ backgroundColor: "none" }} width="20%">
                      {" "}
                      {/* Nhân viên */}
                    </th>
                    <th style={{ backgroundColor: "none" }} width="10%">
                      {/* Phân bổ (%) */}
                    </th>
                    <th style={{ backgroundColor: "none" }} width="15%">
                      {/* Phân bổ (tiền) */}
                    </th>
                    <th style={{ backgroundColor: "none" }} width="10%">
                      {/* Phí */}
                    </th>
                    <th style={{ backgroundColor: "none" }} width="15%">
                      {/*đã khóa */}
                    </th>
                    {editable && !hiddenAddStaff && (
                      <th style={{ backgroundColor: "none" }} width="10%">
                        <Tooltip title="Thêm nhân viên">
                          <IconButton
                            size="small"
                            className="btn-orange ml-1"
                            disabled={!editable}
                            onClick={() =>
                              push({
                                position: null,
                                staff: null,
                                percentRevenue: 100,
                                actualAmount: row?.moneyAfterDiscount,
                              })
                            }
                            sx={{
                              flexShrink: 0,
                            }}
                          >
                            <Add />
                          </IconButton>
                        </Tooltip>
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {row?.staffRevenues?.map((el, indexChild) => {
                    let nameSpaceParent = `items[${index}].staffRevenues`;
                    const locked = el?.locked;
                    return (
                      <tr>
                        <td align="center">{indexChild + 1}</td>
                        <td>
                          <GlobitsPagingAutocomplete
                            api={pagingCustomerSource}
                            name={`${nameSpaceParent}[${indexChild}].source`}
                            autoUpercase
                            searchObject={{
                              level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                              listCustomerSourceCode:
                                arrayselectedSourceCodes?.length > 0
                                  ? arrayselectedSourceCodes
                                  : null,
                            }}
                            disabled={!editable || locked}
                          />
                        </td>
                        <td>
                          <GlobitsPagingAutocomplete
                            name={`${nameSpaceParent}[${indexChild}].position`}
                            api={pagingPosition}
                            searchObject={{
                              isUsing: true,
                              positionCodes: POSITION_CODES,
                            }}
                            disabled={!editable || locked}
                            onChange={function (_, value) {
                              setFieldValue(
                                `${nameSpaceParent}[${indexChild}].position`,
                                value
                              );
                              setFieldValue(
                                `${nameSpaceParent}[${indexChild}].staff`,
                                null
                              );
                            }}
                          />
                        </td>
                        <td style={{ fontWeight: "bold" }}>
                          <GlobitsPagingAutocomplete
                            api={pagingStaff}
                            displayLabel="staffName"
                            name={`${nameSpaceParent}[${indexChild}].staff`}
                            autoUpercase
                            searchObject={{
                              isActive: true,
                              excludeStatus: EXCLUDE_QUIT_STAFF,
                              positionId:
                                getIn(
                                  values,
                                  `${nameSpaceParent}[${indexChild}].position`
                                )?.id || "",
                            }}
                            onChange={function (_, value) {
                              setFieldValue(
                                `${nameSpaceParent}[${indexChild}].staff`,
                                value
                              );
                              const position = getIn(
                                values,
                                `${nameSpaceParent}[${indexChild}].position`
                              );
                              if (!position) {
                                setFieldValue(
                                  `${nameSpaceParent}[${indexChild}].position`,
                                  value?.position
                                );
                              }
                            }}
                            disabled={!editable || locked}
                          />
                        </td>
                        <td align="right">
                          <GlobitsNumberInput
                            name={`${nameSpaceParent}[${indexChild}].percentRevenue`}
                            onChange={(e) => {
                              let percentRevenue = +e?.target?.value;
                              setFieldValue(
                                `${nameSpaceParent}[${indexChild}].percentRevenue`,
                                percentRevenue
                              );
                              setFieldValue(
                                `${nameSpaceParent}[${indexChild}].actualAmount`,
                                (percentRevenue * row?.moneyAfterDiscount) / 100
                              );
                            }}
                            disabled={!editable || locked}
                          />
                        </td>
                        <td align="right">
                          <span title="Tiền phân bổ">
                            <GlobitsVNDCurrencyInputOnlyChange
                              isOnlyOnChange
                              name={`${nameSpaceParent}[${indexChild}].actualAmount`}
                              disabled={!editable || locked}
                              onChange={(e) => {
                                let actualAmount = +e?.target?.value;
                                setFieldValue(
                                  `${nameSpaceParent}[${indexChild}].actualAmount`,
                                  actualAmount
                                );

                                setFieldValue(
                                  `${nameSpaceParent}[${indexChild}].percentRevenue`,
                                  (actualAmount / row?.moneyAfterDiscount) * 100
                                );
                              }}
                            />
                          </span>
                        </td>
                        <td align="right">
                          <span title="Phí lãi suất">
                            <GlobitsVNDCurrencyInputOnlyChange
                              isOnlyOnChange
                              name={`${nameSpaceParent}[${indexChild}].installmentFee`}
                              disabled
                            />
                          </span>
                        </td>
                        <td>{locked ? "Đã khóa" : "Chưa khóa"}</td>
                        {editable && (
                          <td align="center">
                            <IconButton
                              size="small"
                              disabled={!editable || locked}
                              onClick={() => {
                                remove(indexChild);
                              }}
                              sx={{
                                flexShrink: 0,
                              }}
                            >
                              <IconDelete />
                            </IconButton>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}
      </FieldArray>
    </>
  );
};

export default observer(StaffRevenuesFee);
